import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button
} from 'antd';

class Dialog extends Component {
  componentDidMount() {
    this.scrollToBottom();
  };

  componentDidUpdate() {
    this.scrollToBottom();
  };

  scrollToBottom() {
    if (this.props.hasScroll) {
      setTimeout(
        () => this.el && this.el.scrollIntoView({ behavior: 'smooth' }),
        2000
      );
    }
  };

  render() {
    const {
      title,
      visible,
      onOk,
      onCancel,
      content,
      width,
      containerClass,
      hideCancel,
    } = this.props;

    return (
      <Modal
        title={title}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        width={width}
        className={containerClass}
        centered
        footer={[
          <Button
            style={{ 'display' : hideCancel ? 'none' : '' }}
            key="back"
            onClick={onCancel}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={onOk}
          >
            Ok
          </Button>,
        ]}
      >
        <div>
          {content}
          <div ref={el => { this.el = el; }} />
        </div>
      </Modal>
    );
  }
}

Dialog.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  content: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.object.isRequired,
  ]),
  containerClass: PropTypes.string,
  width: PropTypes.number,
};

export default Dialog;
